<template>
    <div class="bg-fff pa-t-16 pa-l-56 pa-b-20 width920px user-message">
        <div class="titles-right font-style">我的证书</div>
        <div class="flex f-wrap ma-t-20" v-if="dataList && dataList.length>0">
            <div class="cert-box"
                 v-for="(item, index) in dataList"
                 :key="index">
                <img :src="item.CertPath" alt="" srcset="" />
                <div class="t-center"><a class="iconfont icon-xiazai" :href="item.CertPath+'?response-content-type=application/octet-stream'" download></a></div>
            </div>
        </div>
        <Empty class="height50" :isShow="!dataList || dataList.length==0"></Empty>

    </div>
</template>

<script>
    var _this;
    import { getMycertificate  } from "../api";
    export default {
        name: "mycertificate",
        data() {
            return {
                dataList: []
            };
        },
        mounted() {
            _this = this;
            _this.loadDataList();
        },
        methods: {
            //下载证书图片
            downCert(url) {
                let a = document.createElement("a"); // 生成一个a元素
                let event = new MouseEvent("click"); // 创建一个单击事件
                a.href = url; // 将生成的URL设置为a.href属性
                a.dispatchEvent(event); // 触发a的单击事件
            },
            loadDataList() {
                getMycertificate().then((res) => {
                    this.dataList = res.data.Data;
                });
            },
        },
    };
</script>

<style lang="scss">

    /* 大屏 宽度大于768 */
    @media (min-width: 768px) {
        $certHeight: 848px;

        .btn-downcert {
            display: inline-block;
            text-align: center;
            cursor: pointer;
            background: #fa004c;
            color: #fff;
            padding: 5px 10px;
            font-size: 12px;
        }

        .fon-7 {
            font-size: 7px;
        }

        .c-logo {
            color: #fa004c;
        }

        .cert-box {
            width: 30%;
            margin-right: 3%;
            margin-bottom: 20px;

            img {
                width: 100%;
            }
        }

        .titles-right:before {
            content: "|";
            display: inline-block;
            width: 4px;
            height: 19px;
            background: #fb004d;
            color: #fb004d;
            border-radius: 2px;
            margin-right: 8px;
        }

        .width920px {
            width: 920px;
        }

        .font-style {
            font-size: 14px;
            font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
            font-weight: bold;
        }

        .tab-active {
            border-bottom: 2px solid #fb004d;
        }

        .img_certificate {
            width: 180px;
            height: 230px;
        }

        .other-img-item {
            width: 180px;
            margin-right: 20px;

            img {
                width: 100%;
                height: 100px;
                object-fit: contain;
                background: #ddd;
            }
        }
    }
</style>